// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"61cfb6aa","239":"88e2a797","455":"50a30e3f"}[chunkId] + ".chunk.js";
};